import { Upload, Typography, Flex, Space, Checkbox, App, Button } from "antd";
import { BTN_TXT, DESC_TXT } from "../../constants/constants";
import { useState } from "react";
import FilePreviewModal from "./FilePreviewModal";
import "./DocUploadCard.scss";

const { Text } = Typography;

const EntDocUploadCard = ({
  doc,
  mouChecked,
  setMouChecked,
  uploadedFile,
  onFileChange,
}) => {
  const { message } = App.useApp();
  const [previewOpen, setPreviewOpen] = useState(false);

  const uploadProps = {
    beforeUpload: (file) => {
      const { allowedTypes, maxSizeMB, fileTitle } = doc;
      const isValidType = allowedTypes.includes(file.type);

      if (!isValidType) {
        const allowedExtensions = allowedTypes
          .map((type) => {
            switch (type) {
              case "application/pdf":
                return "PDF";
              case "image/png":
                return "PNG";
              case "image/jpeg":
              case "image/jpg":
                return "JPG";
              case "image/webp":
                return "WEBP";
              default:
                return type;
            }
          })
          .join(", ");

        message.error(`${fileTitle} supports only ${allowedExtensions} files`);

        return Upload.LIST_IGNORE;
      }

      const fileSizeMB = file.size / 1024 / 1024;

      if (fileSizeMB > maxSizeMB) {
        message.error(`${fileTitle} cannot exceed ${maxSizeMB} MB`);

        return Upload.LIST_IGNORE;
      }

      onFileChange(file);

      return false;
    },

    showUploadList: false,
  };

  return (
    <div className="doc-upload-card">
      <Flex align="center" justify="space-between" gap={20}>
        <Space direction="vertical" size="small">
          <Text className="file-title">{doc.title}</Text>
          {uploadedFile ? (
            <div style={{ marginTop: 8 }}>
              <Text type="secondary">
                {typeof uploadedFile === "string"
                  ? uploadedFile.split("/").pop()
                  : uploadedFile?.name}
              </Text>
            </div>
          ) : (
            <Text className="file-desc">{`${DESC_TXT.UPLOAD_DOC_DESC} ${doc.type}`}</Text>
          )}
        </Space>

        {doc.key === "mou" && !uploadedFile && (
          <Flex vertical align="center" gap={5}>
            <Checkbox
              checked={mouChecked === true}
              onChange={() => setMouChecked(true)}
            >
              Yes
            </Checkbox>
            <Checkbox
              checked={mouChecked === false}
              onChange={() => setMouChecked(false)}
            >
              No
            </Checkbox>
          </Flex>
        )}

        <Flex gap={8}>
          {!uploadedFile ? (
            <Upload
              {...uploadProps}
              accept={doc.allowedTypes.join(", ")}
              disabled={doc.key === "mou" && mouChecked !== true}
            >
              <Button
                type="primary"
                disabled={doc.key === "mou" && mouChecked !== true}
              >
                {BTN_TXT.UPLOAD}
              </Button>
            </Upload>
          ) : (
            <Flex gap={8}>
              <Button type="primary" onClick={() => setPreviewOpen(true)}>
                {BTN_TXT.VIEW}
              </Button>
              <Button danger onClick={() => onFileChange(null)}>
                {BTN_TXT.DELETE}
              </Button>
            </Flex>
          )}
        </Flex>
        <FilePreviewModal
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          file={uploadedFile}
          title={doc.title}
        />
      </Flex>
    </div>
  );
};

export default EntDocUploadCard;
